import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEventResults } from "@/api/williams/testEvents";
import { useMutation, useQueryClient } from "react-query";

export function useSaveTestResults() {
  const queryClient = useQueryClient();

  return useMutation(async (results: TestEventResults) => {
    const updatedResults = await api.saveTestResults(results);
    queryClient.invalidateQueries(queryKeys.testEvent.single(results.testEvent.id));
    return updatedResults;
  });
}
